/* @ngInject */
const area = (areaAsk,
  areaData,
  areaFormat,
  areaGo,
  areaLocal,
  areaMetadata,
  areaRequest
) => {
  const self = {}

  self.new = () => {
    return {
      id: null,
      idNull: 'any',
      idOperator: '=',
      name: null,
      nameNull: 'any',
      nameOperator: '=',
      isReal: false,
    }
  }

  self.ask = areaAsk
  self.data = areaData
  self.format = areaFormat
  self.go = areaGo
  self.local = areaLocal
  self.metadata = areaMetadata
  self.request = areaRequest

  return self
}

export default area



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/area/services/area.service.js